<template lang="pug">
  .component-reveal
    .trigger-wrapper(:data-open="uid")
      slot(name="trigger")
    .reveal(:id="uid", data-reveal='')
      slot
      button.close-button(data-close='', aria-label='Close modal', type='button')
        span(aria-hidden='true') ×
      .confirm-buttons(v-if="confirm")
        button.button.success.yes(data-close='', v-on:click="confirm") Yes
        button.button.alert.float-right(data-close='') No

</template>
<script type="text/babel">
  export default {
    name: 'Reveal',
    components: {},
    data() {
      return {}
    },
    mounted() {
      new Foundation.Reveal($(this.$el).find('.reveal'))
    },
    methods: {
      confirm() {
        this.$emit('confirm')
      },
    },
    computed: {
      uid() {
        return 'reveal-' + this._uid
      }
    },
    props: ['confirmButtons']
  }
</script>
<style lang="sass" rel="stylesheet/sass">
  .reveal
    .confirm-buttons
      margin-top: 2em
</style>



// WEBPACK FOOTER //
// Reveal.vue?56041498